import type { TabularDataCell, TabularRow } from "../../../../../../../../../api/types/svTypes.ts";

export const getFormattedValueWithFallback = (cell: TabularDataCell | undefined) => {
  return cell?.formattedValue || "No Value";
};

export const getCellFromRow = (row: TabularRow | null, fieldGuid: string): TabularDataCell | undefined => {
  return row?.data?.[fieldGuid] as TabularDataCell;
};
